import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classnames from 'classnames';
import React__default, { useEffect } from 'react';
import { SET_SORTED_DISPLAY_DATA } from '../utils/constants.js';
import { useTable } from '../utils/hooks.js';
import { sliceRowsByItemRange } from '../utils/rowUtils.js';
import FirstParentRecursiveRowGroup from './FirstParentRecursiveRowGroup.js';
import NoRowData from './NoRowData.js';
import Row from './Row.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/**
 * Rows - Contains the UX for regular rows and row groupings
 * @param {object} props
 * @param {string} props.tableName unique identifier for table for row selection to bind with
 * @returns {any}
 */

var Rows = function Rows(_ref) {
  var tableName = _ref.tableName;
  var _useTable = useTable(),
    dispatch = _useTable.dispatch,
    _useTable$state = _useTable.state,
    displayData = _useTable$state.displayData,
    columns = _useTable$state.columns,
    isClient = _useTable$state.isClient,
    pagination = _useTable$state.pagination,
    rowSelection = _useTable$state.rowSelection;
  var itemRange = pagination.itemRange;
  var columnDefsRef = columns.columnDefs.map(function (def) {
    return def.sortDirection;
  }).toString();

  //TODO: REMOVE?
  // Set and sort whenever columns change for non groups rows
  // Set data for group rows if it hasn't been set
  useEffect(function () {
    if (!columns.hasRowGroup) {
      dispatch({
        type: SET_SORTED_DISPLAY_DATA
      });
    }
  }, [columnDefsRef, columns.hasRowGroup, dispatch]);

  // TODO: consolidate into column util
  var classesForColumns = columns.columnDefs.reduce(function (obj, _ref2) {
    var field = _ref2.field,
      align = _ref2.align,
      pinned = _ref2.pinned;
    return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, field, classnames(_defineProperty(_defineProperty({}, "--text-align-".concat(align), align), '--pinned', pinned))));
  }, {});

  // TODO: wrap in helper as above
  var stylesForColumns = columns.columnDefs.reduce(function (prev, _ref3) {
    var field = _ref3.field,
      width = _ref3.width,
      pinned = _ref3.pinned;
    var newPinOffset = pinned ? prev.pinOffset + width : prev.pinOffset;
    return _objectSpread(_objectSpread({}, prev), {}, _defineProperty(_defineProperty({}, field, {
      left: pinned ? "".concat(prev.pinOffset, "px") : undefined
    }), "pinOffset", newPinOffset));
  }, {
    pinOffset: rowSelection ? 45 : 0
  });
  if (displayData.length <= 0) {
    return /*#__PURE__*/React__default.createElement(NoRowData, null);
  }

  // Non row group UX
  if (!columns.hasRowGroup) {
    var slicedRowData = sliceRowsByItemRange(displayData, (itemRange === null || itemRange === void 0 ? void 0 : itemRange.start) - 1, itemRange === null || itemRange === void 0 ? void 0 : itemRange.end, isClient);
    return slicedRowData.map(function (row, index) {
      var rowIndex = "row-".concat(index);
      return /*#__PURE__*/React__default.createElement(Row, {
        key: rowIndex,
        singleRowData: row,
        columnOrder: columns.columnDefs,
        classesForColumns: classesForColumns,
        stylesForColumns: stylesForColumns,
        id: rowIndex,
        tableName: tableName
      });
    });
  }
  return /*#__PURE__*/React__default.createElement(FirstParentRecursiveRowGroup, null);
};

export { Rows as default };
